/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Comment_LabelInputs */

const es_feedback_modal_comment_label = /** @type {(inputs: Feedback_Modal_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentario enviado`)
};

const en_feedback_modal_comment_label = /** @type {(inputs: Feedback_Modal_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted comment`)
};

/**
* | output |
* | --- |
* | "Submitted comment" |
*
* @param {Feedback_Modal_Comment_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_comment_label = /** @type {((inputs?: Feedback_Modal_Comment_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Comment_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_comment_label(inputs)
	return en_feedback_modal_comment_label(inputs)
});
export { feedback_modal_comment_label as "feedback.modal.comment_label" }